import React, { Component } from 'react';
import DataFetcher from '../utils/DataFetcher';
import DevicePage from '../components/DevicePage';

class DeviceOfDelegate extends Component {
  constructor(props) {
    super(props)
    this.delegateId = this.props.match.params.delegateId
  }

  render() {
    const pageProps = {
      fetchSites: (params, callback) => {
        DataFetcher.delegateSites(
          {
            delegateId: this.delegateId
          }, 
          {
            success: callback
          }
        )
      },
      fetchDevices: (params, callback) => {
        DataFetcher.delegateDevices(
          {
            ...params,
            delegateId: this.delegateId,
          }, 
          {
            success: callback
          }
        )
      },
      fetchStatistic: (params, callback) => {
        DataFetcher.delegateDeviceStatistic(
          {
            ...params,
            delegateId: this.delegateId
          }, 
          {
            success: callback
          }
        )
      },
      fetchDeviceTypes: (params, callback) => {
        DataFetcher.deviceTypes(
          {
            ...params,
            delegateId: this.delegateId
          }, 
          {
            success: callback
          }
        )
      },
      updateDevice: (params, callback, completed) => {
        DataFetcher.delegateUpdateDevice(
          {
            ...params,
            delegateId: this.delegateId
          }, 
          {
            success: callback,
            completed
          }
        )
      },
      logoutDevice: (params, callback) => {
        DataFetcher.delegateLogoutDevice(
          {
            ...params,
            delegateId: this.delegateId
          }, 
          {
            success: callback
          }
        )
      },
      restartDevice: (params, callback) => {
        DataFetcher.delegateRestartDevice(
          {
            ...params,
            delegateId: this.delegateId
          }, 
          {
            success: callback
          }
        )
      },
      alertDevice: (params, callback, completed) => {
        DataFetcher.delegateDeviceAlert(
          {
            ...params,
            delegateId: this.delegateId
          }, 
          {
            success: callback,
            completed
          }
        )
      },
      sendGift: (params, callback, completed) => {
        DataFetcher.delegateGift(
          {
            ...params,
            delegateId: this.delegateId
          }, 
          {
            success: callback,
            completed
          }
        )
      },
      deviceLogLink: (record) => {
        return `/delegate/device_log/${encodeURIComponent(record.deviceId)}?delegateId=${this.delegateId}`
      },
      delegateProfile: (params, callback) => {
        DataFetcher.delegateProfile(
          {
            ...params,
            id: this.delegateId
          }, 
          {
            success: callback
          }
        )
      }
    }

    return <DevicePage {...pageProps}/>
  }
}

export default DeviceOfDelegate;


// WEBPACK FOOTER //
// ./src/modules/DeviceOfDelegate.js